<template>
  <el-dialog
    title="修改工作组"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :modal="false"
    width="500px"
  >
    <div>
      <div class="mb10">
        <p class="dialog-title mb10">1:基本信息</p>
        <p class="mb10">用户名：{{ member.account }}</p>
      </div>

      <div class="mb10">
        <p class="dialog-title mb10">
          2:职能权限 <el-button type="primary" size="mini" @click="editCategory">编辑</el-button>
        </p>
        <div class="tag-box mb10">
          <el-tag v-for="tag in member.职能模块" :key="tag" class="mr10 mb10" size="mini">{{ tag }}</el-tag>
        </div>
      </div>
    </div>
    <!-- <ChooseCategory
      ref="ChooseCategory"
      :modal="false"
      :show-category-detail="false"
      @confirm="addFunction"
    ></ChooseCategory> -->
    <SimpleChooseCategory ref="SimpleChooseCategory" @confirm="addFunction"></SimpleChooseCategory>
    <span slot="footer" class="dialog-footer">
      <div class="radish-btn radish-btn-primary radish-btn-small" @click="dialogVisible = false">关 闭</div>
      <div class="radish-btn radish-btn-primary radish-btn-small" @click="confirm">确 定</div>
    </span>
  </el-dialog>
</template>
<script>
// import ChooseCategory from './ChooseCategory'
import SimpleChooseCategory from './SimpleChooseCategory'

export default {
  // components: { ChooseCategory },
  components: { SimpleChooseCategory },
  data() {
    return {
      dialogVisible: false,
      accounts: [],
      member: {},
      teamsData: [],
    }
  },
  async mounted() {
    await this.getTeamsData()
  },
  methods: {
    async getTeamsData() {
      const res = await app.service('company').getTeamsData()
      if (res.status === 'success') {
        this.teamsData = res.data
      } else {
        this.$message.info(res.msg)
      }
    },
    editCategory() {
      const { parentTeam, team } = this
      const memberCate = (this.member.SL权限 || '').split(';')
      // this.$refs.ChooseCategory.open(this.team.职能模块 || [], memberCate)
      this.$refs.SimpleChooseCategory.open((team.depth === 3 ? parentTeam.职能模块 : team.职能模块) || [], memberCate)
    },
    async getAccounts() {
      const res = await app.service('misc').listAccounts()
      this.accounts = (res.data || []).filter(v => v && v.状态 !== '离职中' && v.状态 !== '已离职')
    },
    addFunction(arr = []) {
      // const arr = func.map(val => val.名称)
      this.$set(this.member, '职能模块', arr)
      this.$set(this.member, 'SL权限', arr.join(';'))
    },
    async open(team, member) {
      await this.getAccounts()
      const parentTeam = this.teamsData.find(v => v._id === team.parentId)
      if (!parentTeam) team.depth = 1
      else if (parentTeam.parentId) team.depth = 3
      else team.depth = 2
      this.parentTeam = parentTeam
      this.team = team
      try {
        const memberWithId = this.accounts.find(v => v.account === member) || {}
        const res = await app.service('users').get(memberWithId._id)
        res.职能模块 = (res.SL权限 || '').split(';')
        this.member = res
      } catch (e) {
        this.$message.error(e.message)
      }
      this.dialogVisible = true
    },
    getUserName(row) {
      const val = (this.accounts || []).find(v => v.account === row)
      return val && val.姓名
    },
    async confirm() {
      if (this.loading) return
      this.loading = true
      try {
        await app.service('users').patch(this.member._id, { SL权限: this.member.SL权限 })
        this.$message.success('修改成功')
        this.dialogVisible = false
      } catch (e) {
        this.$message.error(e.message)
      }
      this.loading = false
    },
  },
}
</script>
<style scoped>
.dialog-title {
  font-size: 16px;
  font-weight: 700;
}
</style>
